<template>
<!-- Modal -->
<Modal ref="modal" :id="'editActContentModal' + activity.id" :savePromise="save" :prepareFunc="prepare">
  <template #content>
    <div class="modal-header">
      <h4 class="model-title" style="text-align:center">任務</h4>
    </div>
    <div class="modal-body" style="margin:12px;">
      <form>
        <div class="row">
          <div class="col-md-6">
          <md-field>
            <label>標題</label>
            <md-input id="title" name="name" v-model="name" />
          </md-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" style="margin-top: 20px;">
            <md-field>
            <label>簡介（選填）</label>
            <md-textarea type="text" id="desc" name="description" v-model="description" rows='4'></md-textarea>
          </md-field>
          </div>
          <div id="form_edit_act_id" style="display:none"></div>
          <input type="hidden" name="id">
        </div>
      </form>

      <div class="form-group row" style="padding-bottom: 30px;">
        <div class="col-xs-6" style="text-align: center;">
           <el-button plain data-dismiss="modal">取消</el-button>
        </div>
        <div class="col-xs-6" style="text-align: center;">
           <el-button class="save-btn" type="primary" data-dismiss="modal">儲存</el-button>
        </div>
      </div>

    </div>
  </template>
  </Modal>
</template>
<script>
// import $ from 'jquery'
import Modal from '@/components/Utility/Modal'
export default {
  components: {
    Modal
  },
  props: {
    activity: Object
  },
  data () {
    return {
      course: this.$parent.courseId,
      week: this.$parent.weekId,
      id: this.$parent.id,
      name: this.activity.name,
      description: this.activity.description
    }
  },
  methods: {
    save: async function () {
      let fd = new FormData()
      fd.append('name', this.name)
      fd.append('description', this.description)
      try {
        await this.$store.dispatch('request', {
          method: 'post',
          route: `courses/${this.course}/weeks/${this.week}/activities/${this.id}`,
          data: fd
        })

        this.activity.name = this.name
        this.activity.description = this.description
        alert('成功')
        return true
      } catch (err) {
        console.error(err)
        alert('失敗')
        return false
      }
    },
    open: function () {
      this.$refs.modal.open()
    },
    prepare: function () {
      this.name = this.activity.name
      this.description = this.activity.description
    }
  },
  watch: {
    activity: function (a, b) {
      this.name = a.name
      this.description = a.description
    }
  }
}
</script>
